<script setup>
import { computed } from 'vue';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

// The widget reads its own channel config; the settings preview passes the
// values being edited, which have not been saved yet.
const props = defineProps({
  items: { type: Array, default: null },
});

const emit = defineEmits(['select']);

const starters = computed(() =>
  (props.items ?? window.chatwootWebChannel?.conversationStarters ?? []).filter(
    Boolean
  )
);
</script>

<template>
  <div v-if="starters.length" class="flex flex-col gap-0.5">
    <button
      v-for="starter in starters"
      :key="starter"
      type="button"
      class="flex items-start w-full gap-3 px-3 py-2.5 text-left transition-colors rounded-xl hover:bg-n-slate-3"
      @click="emit('select', starter)"
    >
      <FluentIcon
        icon="arrow-reply"
        size="18"
        class="mt-px shrink-0 -scale-x-100 text-n-slate-10"
      />
      <span class="text-sm text-n-slate-12">{{ starter }}</span>
    </button>
  </div>
</template>
